// extracted by mini-css-extract-plugin
export default {"component":"CheckBox_component__FpV82","disabled":"CheckBox_disabled__zsKhJ"};